import { render, staticRenderFns } from "./returnModel.vue?vue&type=template&id=edbdd7c8&scoped=true"
import script from "./returnModel.vue?vue&type=script&lang=js"
export * from "./returnModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbdd7c8",
  null
  
)

export default component.exports